// extracted by mini-css-extract-plugin
export default {"DomainLoadingContainer":"DomainLoading_DomainLoadingContainer__AHfMw","DomainLoading":"DomainLoading_DomainLoading__g3phG","Lottie":"DomainLoading_Lottie__anz6C"};